// True only for well-formed https: URLs; used to keep links and images from
// API data safe to render.
export default function isHttpsUrl(value) {
  try {
    return new URL(value).protocol === "https:";
  } catch (e) {
    return false;
  }
}
